export enum NotificationTypes {
  CHNNL = 'chnnl',
  ORGANISATION = 'organisation',
}
